module.exports = __webpack_public_path__ + "static/media/shop.6209acf8.svg";